export default __webpack_public_path__ + "static/media/avatar.c2cfb804.svg";